import React from 'react'

import ListFriend from './ListFriend'
import ListFriendAdd from './ListFriendAdd'
import ListFriendUser from './ListFriendUser'
import LoadingIcon from './LoadingIcon'

const Friends = ({ user, friends, friendsPath }) => {
  let friendsList = ''

  if (friends !== undefined) {
    if (friends.length > 0) {
      let friendsListItems = ''
      friendsListItems = friends.map(item => (
        <ListFriend
          key={item.accountId}
          friend={item}
          friendsPath={friendsPath}
        />
      ))
      friendsList = (
        <ul className="friends-list">
          <ListFriendAdd friendsPath={friendsPath} />
          <ListFriendUser user={user} friendsPath={friendsPath} />
          {friendsListItems}
        </ul>
      )
    } else {
      friendsList = (
        <div>
          <div className="warning text-center">
            You have not added any friends yet. Add a friend so you can share
            recipes and message each other in Cook'n!
          </div>
          <ul className="friends-list">
            <ListFriendAdd friendsPath={friendsPath} />
            <ListFriendUser user={user} friendsPath={friendsPath} />
          </ul>
        </div>
      )
    }
  } else {
    friendsList = (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <LoadingIcon />
      </div>
    )
  }

  return (
    <div>
      <h2 className="text-center">My Cook'n Friends</h2>
      {friendsList}
    </div>
  )
}

export default Friends



// WEBPACK FOOTER //
// ./src/Components/Friends.js